<template>
  <a-result
    status="success"
    title="操作成功"
  >
    <template #extra>
      <a-button key="console" type="primary">
        继续编辑
      </a-button>
      <a-button key="buy">
        返回列表
      </a-button>
    </template>
  </a-result>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
